import { FileUploadProgressDTO } from "@js/DTO/FileUploadProgressDTO.cs.d";
import { AuthService } from "@js/services/AuthService";
import { CaseService } from "@js/services/CaseService";
import { RoleService } from "@js/services/RoleService";
import { SelectListService } from "@js/services/SelectListService";
import angular from "angular";
import {
  AccountClient,
  ApplicationUser,
  ApplicationUserClient,
  ApplicationUserCrudClient,
  AppPackagePricing,
  BrickflowEventLogClient,
  Case,
  CaseAccessLevelEnum,
  CaseClient,
  CaseCrudClient,
  CaseLender,
  CaseLenderClient,
  CaseLenderStateEnum,
  CaseMember,
  CaseMemberClient,
  CaseNote,
  CaseNoteClient,
  CaseStatusEnum,
  ComparableProperty,
  ComparablePropertyClient,
  DealFileAttachmentClient,
  DevelopmentInput,
  DevelopmentInputClient,
  DevelopmentInputCrudClient,
  EventLogEnum,
  ExternalLinks,
  ExternalLinksClient,
  ExternalLinksEnum,
  FileAttachment,
  FileAttachmentClient,
  FileAttachmentCrudClient,
  LenderClient,
  LenderInfo,
  LenderProductTypeEnum,
  LenderResultMinimalDTO,
  LicenseMasterStatusEnum,
  ModuleEnum,
  Organisation,
  OrganisationClient,
  Product,
  ProductClient,
  ProductFamilyEnum,
  ProductTypeEnum,
  TeamMember,
  TeamMemberClient,
  UserClient,
} from "@src/apis/ModularClient";
import ProductHelper from "@js/helpers/ProductHelper";
import { DealFileAttachmentHelper } from "@js/helpers/DealFileAttachmentHelper";
import { FileAttachmentHelper } from "@js/helpers/FileAttachmentHelper";
import { ModuleAppFeatureDTO } from "@js/DTO/ModuleAppFeatureDTO.cs";
import { Expand } from "@ccq/ts-lib";
import { IndexService } from "@js/services/IndexService";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class CaseController {
  dataLoading: boolean = false;

  assistanceSlider: boolean = false;
  totalLender: number = 0;

  selectedSection: string;

  thisModuleSection: ModuleEnum;
  fileUpload: Expand<FileAttachment, {}>[];
  fileUploadPlaning: FileAttachment[];
  fileUploadTeam: FileAttachment[];
  fileUploadProperties: FileAttachment[];
  selectedProduct: Product;
  selectedResult: LenderResultMinimalDTO;
  total: number = 0;
  openModal: boolean = false;
  objects: Expand<
    Case,
    {
      readonly attachments: true;
      readonly developmentInput: { readonly selectedResults: true };
      readonly links: true;
      readonly caseNotes: true;
      readonly teamMembers: true;
      readonly comparables: true;
    }
  >[]; //TODO JLH rename this to something meaningful but look into what it is used for
  case: Expand<
    Case,
    {
      readonly attachments: true;
      readonly developmentInput: { readonly selectedResults: true };
      readonly links: true;
      readonly caseNotes: { readonly user: true };
      readonly teamMembers: true;
      readonly comparables: true;
    }
  >;
  toggleEditSearchName: boolean = false;
  orgName: string;
  orgId: number;
  org: Organisation;
  fileNamePrefix: string = "Brickflow";

  caseLenders: CaseLender[];
  // indicates whether a bid has been accepted on the case
  hasBidAccepted: boolean = false;
  selectedCaseLender: CaseLender;

  ShowProceed: boolean = false;
  showEdit: boolean = false;
  confirmationDelete: boolean = false;

  uploadingFiles: FileUploadProgressDTO[];
  renamingFile: FileAttachment;

  //to populate the full login details
  showSetPasswordModal: boolean = false;
  verifyNewPassword: string;
  passwordSetSuccess: boolean = false;
  registrationForm: FormData;
  modal: ng.IFormController;

  newNote: CaseNote;
  newExternalLink: ExternalLinks;
  newTeamMember: TeamMember;
  editTeamMember: TeamMember;
  tempTeamMember: TeamMember;
  confirmDeleteTeamMember: TeamMember;
  newComparable: ComparableProperty;
  editComparable: ComparableProperty;
  tempComparable: ComparableProperty;
  confirmDeleteComparable: ComparableProperty;
  appName: string;

  clickRequestReview: boolean = false;

  //check Payment Status and show modal
  paymentStatus: string;

  IsOnlyBroker: boolean = false;
  isAdminBroker: boolean = false;
  isBroker: boolean = false;
  isAdmin: boolean = false;
  isLender: boolean = false;
  isClient: boolean = false;
  showVideo: boolean = false;
  showShare: boolean = false;
  shareContext: number = null;
  shareSuplId: number = null;
  shareNote: string;
  userFirstName: string;
  showAdd: boolean = false;
  showDelete: boolean = false;
  showReject: boolean = false;
  showWithdraw: boolean = false;
  showStatusMessage: boolean = false;
  isCaseMember: boolean = false;
  redactSensitiveInfo: boolean = false;
  invalidEmail: boolean = false;

  caseForm: ng.IFormController;
  externalLinkForm: ng.IFormController;
  teamMemberForm: ng.IFormController;
  editTeamMemberForm: ng.IFormController;
  comparableForm: ng.IFormController;
  editComparableForm: ng.IFormController;
  planningForm: ng.IFormController;
  shareForm: ng.IFormController;
  lenderDetailsForm: ng.IFormController;

  showExport: boolean = false;
  //case overview
  caseOverviewTempBackup: string;
  //planning
  planningURLTempBackup: string;
  planningLocalAuthorityTempBackup: string;
  planningReferenceTempBackup: string;
  planningDescriptionTempBackup: string;
  lenderDetails: CaseLender;

  caseMembersWithAccess: CaseMember[];
  selectedClientToShareWith: CaseMember;

  isInActiveLender: boolean = false;
  brokerCommission: number | null = null;
  caseBrokerUser: ApplicationUser;
  password: string = null;
  //carousel
  carouselData: string[] = [
    "Brickflow is the quickest and easiest way to apply for development finance.",
    "To get a Decision in Principle (DIP) from a Lender please complete the Appraisal modules below.",
    "The Decision in Principle may be different to the estimates you saw on the results screen.\nThe Decision in Principle is an accurate quote directly from the lender. ",
    "The lender is basing their Decision in Principle only on the information provided below in the Appraisal,\nso be sure to really showcase you and your project.",
    "The Decision in Principle should be provided to you within 48 - 72 hours of you completing the Appraisal.\nNo credit scores will be carried out to provide a Decision in Principle.",
    "The loan still needs to be approved by Credit Committee, but providing a Decision in Principle means the lender is confident in getting approval (but it's not guaranteed)",
    "Select 'Complete' against each Module once you're happy.\nOnce all modules are complete click 'Submit to Lenders'.",
    "A Brickflow Team Member will review your Case and then when they're happy,\nyour Case will be sent to the chosen lender(s) for review.",
    "Your Developer Profile is like a CV. It will be saved and updated as you complete loans in the platform. Complete it once and never have to do it again.",
    "When you're ready to start, click module 1 'Case Overview'",
  ];
  carouselStep: number = 0;

  caseLandingSeen: boolean = true;

  message: boolean = false;
  messageContent: string;
  sendingMessage: boolean = false;

  maxNotes: number = 3;
  showAllNotes: boolean = false;

  showRequestEmailForm: boolean = false;
  requestMessageReason: string = "";
  enquiryTelephone: string = "";

  // Controls showing Ts & Cs when a borrower/broker submits to lenders
  showTsAndCs: boolean = false;
  showTsAndCsForm: boolean = false;
  showApplyTsAndCs: boolean = false;
  acceptTerms: boolean = false;

  youtubeLinkToAdd: string;
  currentYoutubeVideo: string = "";

  //For build costs calculation
  totalBuild: number;
  additionalBuild: number;
  contingencyTotal: number;
  totalPurchaseCostsNotOwning: number;
  totalPurchaseCostsOwning: number;

  shareholders: CaseMember;

  //Accordion

  accordionShow: boolean[] = [];

  //Admin viewing on behalf

  proxyViewer: boolean = false;

  clientUsernameBeingAccessed: string;
  tinymceOptions: any;
  //Guidance
  guidanceCheckbox: boolean = true;
  tourState: any = {
    tourStep: 1,
    tourTotalSteps: 0,
  };
  tourEnabled: boolean = false;
  brokerOrganisations: Organisation[];
  brokerUsers: ApplicationUser[];

  seeFiles: boolean = false;

  isLoggedInUser: boolean = false;

  primaryShareholder: CaseMember;
  brokerEmail: string;

  isSelected: boolean = false;
  selectedPaymentProduct: AppPackagePricing = null;
  showPaymentModal: boolean = false;
  moduleAppFeatures: ModuleAppFeatureDTO[];
  moduleFeatureCount: number = 0;
  selecteFeatureCount: number = 0;
  appPackagePrices: AppPackagePricing[];
  selectedProductList: AppPackagePricing[] = [];
  billingFrequency: Array<{ id: number; value: string }> = [
    { id: 1, value: "Monthly" },
    { id: 2, value: "Yearly" },
  ];
  selectedBillingFrequency: number;
  isSubmittedToLenders: boolean = false;

  selectedLendersText: string = "";
  shortlistedLendersText: string = "";
  lendersDetailsForSubmittoLenders: LenderInfo[];
  shortListedLendersId: number[];

  referrerOptions = [];
  locationOptions = [];

  hasShortlistedCaseLenders: boolean;

  showModuleShareConfirmation: boolean;

  productTypeDisplayText: string;

  brokerPreferredContact: string = "";
  isBrokerPhoneNumberUpdated: boolean = false;
  showAutofill: boolean = false;

  totalUnreadCaseLenderMessages: number = 0;

  currentPhoneNumber: string;
  requestAssistancePhoneNumber: string;
  static $inject = [
    "$routeParams",
    "$rootScope",
    "CaseClient",
    "CaseService",
    "DevelopmentInputClient",
    "DevelopmentInputCrudClient",
    "$location",
    "FileAttachmentHelper",
    "FileAttachmentClient",
    "CaseNoteClient",
    "RoleService",
    "AuthService",
    "$cookies",
    "AccountClient",
    "ProductClient",
    "ExternalLinksClient",
    "$interval",
    "$q",
    "$window",
    "UserClient",
    "ApplicationUserCrudClient",
    "ApplicationUserClient",
    "TeamMemberClient",
    "ComparablePropertyClient",
    "CaseLenderClient",
    "LenderClient",
    "OrganisationClient",
    "CaseMemberClient",
    "SelectListService",
    "BrickflowEventLogClient",
    "DealFileAttachmentClient",
    "DealFileAttachmentHelper",
    "IndexService",
    "CaseCrudClient",
    "ODataHelper",
    "FileAttachmentCrudClient",
  ];

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    private $rootScope: ng.IRootScopeService,
    private caseClient: CaseClient,
    private caseService: CaseService,
    private developmentInputClient: DevelopmentInputClient,
    private developmentInputCrudClient: DevelopmentInputCrudClient,
    private $location: ng.ILocationService,
    private fileAttachmentHelper: FileAttachmentHelper,
    private fileAttachmentClient: FileAttachmentClient,
    private caseNoteClient: CaseNoteClient,
    private roleService: RoleService,
    private authService: AuthService,
    private $cookies: ng.cookies.ICookiesService,
    private accountClient: AccountClient,
    private productClient: ProductClient,
    private externalLinksClient: ExternalLinksClient,
    private $interval: ng.IIntervalService,
    private $q: ng.IQService,
    private $window: ng.IWindowService,
    private userClient: UserClient,
    private applicationUserCrudClient: ApplicationUserCrudClient,
    private applicationUserClient: ApplicationUserClient,
    private teamMemberClient: TeamMemberClient,
    private comparablePropertyClient: ComparablePropertyClient,
    private caseLenderClient: CaseLenderClient,
    private lenderClient: LenderClient,
    private organisationClient: OrganisationClient,
    private caseMemberClient: CaseMemberClient,
    private selectListService: SelectListService,
    private eventLogClient: BrickflowEventLogClient,
    private dealFileAttachmentClient: DealFileAttachmentClient,
    private dealFileAttachmentHelper: DealFileAttachmentHelper,
    private indexService: IndexService,
    private caseCrudClient: CaseCrudClient,
    private odataHelper: ODataHelper,
    private fileAttachmentCrudClient: FileAttachmentCrudClient,
  ) {
    if ($cookies.get("access_token")) {
      this.isLoggedInUser = true;

      this.userClient.getCurrentUserAutofill().then((response) => {
        this.showAutofill = response;
      });
    }

    this.productTypeDisplayText = ProductHelper.getProductTypeDisplayText(ProductTypeEnum.Development);

    sessionStorage.removeItem("lenderTask");

    //TOUR
    $rootScope.$on("nextTour", (event: ng.IAngularEvent) => {
      this.tourNext();
    });
    $rootScope.$on("backTour", (event: ng.IAngularEvent) => {
      this.tourBack();
    });
    $rootScope.$on("skipTour", (event: ng.IAngularEvent) => {
      this.tourSkip();
    });

    this.tinymceOptions = {
      content_style: "body {color: #304b9a;font:300 13.33px Roboto,sans-serif;}",
      menubar: false,
      height: 300,
      branding: false,
      statusbar: false,
      plugins: [
        "advlist autolink lists link image charmap print preview anchor",
        "searchreplace visualblocks code fullscreen",
        "insertdatetime media table paste code help wordcount",
      ],
      toolbar:
        "undo redo | formatselect | " +
        "bold italic backcolor forecolor | alignleft aligncenter " +
        "alignright alignjustify | bullist numlist outdent indent | preview fullscreen |" +
        "removeformat | help",
    };

    if ((this.$rootScope as any).acceptTerms) {
      this.showRequestEmailForm = false;
      this.requestMessageReason = "Thank you for accepting the Decision in Principle";
      this.message = true;
      this.messageContent =
        "Once you have made the application payment you will need to review the information in the Application Details module. Once this has been completed you will be able to submit your application to the lender";
    }

    if (this.$routeParams.PaymentStatus) {
      this.paymentStatus = this.$routeParams.PaymentStatus;
    }

    this.getTubeMapValue();

    this.checkForClient();

    if (this.$routeParams.CaseId) {
      this.dataLoading = true;

      this.organisationClient.list().then((response) => {
        this.brokerOrganisations = response;
      });

      this.caseLenderClient.fetchByCaseId(this.$routeParams.CaseId).then((cls: CaseLender[]) => {
        this.hasShortlistedCaseLenders = cls.some((cl) => cl.caseLenderState == CaseLenderStateEnum.Shortlisted);
        this.totalUnreadCaseLenderMessages = cls
          .filter((cls) => cls.totalUnreadCaseLenderMessages != null)
          .reduce((a, b) => a + b.totalUnreadCaseLenderMessages, 0);
      });

      this.odataHelper
        .getOne(this.caseCrudClient, {
          filter: {
            id: {
              eq: Number(this.$routeParams.CaseId),
            },
          },
          expand: {
            developmentInput: { selectedResults: true },
            links: true,
            caseNotes: { user: true },
            teamMembers: true,
            comparables: true,
          },
        })
        .then((responseCase) => {
          this.odataHelper
            .getMany(this.fileAttachmentCrudClient, {
              filter: {
                caseId: {
                  eq: Number(this.$routeParams.CaseId),
                },
              },
            })
            .then((res) => {
              // The case was a pre-existing case when the broker org became a member of Connect and therefore was archived.
              if (responseCase.developmentInput?.isPreConnectArchived) {
                this.$location.path("/dashboard");
              }

              this.case = responseCase as typeof responseCase & { attachments: any[] };
              this.case.attachments = res;
              this.orgId = this.case.brokerOrganisationId;
              if (this.orgId) {
                this.organisationClient.fetch(this.orgId).then((response) => {
                  this.org = response;
                  this.brokerCommission =
                    this.case.caseStatus == CaseStatusEnum.NewCase
                      ? response.commissionPercent
                      : this.case.brokerCommissionPercent;
                  if (this.org.isWhiteLabelled) {
                    this.fileNamePrefix = this.org.name.replace(/ /g, "_");
                  } else {
                    this.fileNamePrefix = "Brickflow";
                  }
                });
              }

              if (this.case) {
                this.fileUpload = this.case.attachments;
                // UpdateCaseState is essential to the RequiredState directive functionality
                //TODO JNG refactor to put within the caseservice fetch
                if (this.case) {
                  ($rootScope as any).statusRequirementId = this.case.id;

                  this.caseService.updateCaseState(this.case.id, this.case.caseStatus);

                  if (this.case.caseStatus == 0 || this.case.caseStatus == 1) {
                    this.caseService.updateTubeMap(CaseStatusEnum.InProgress);
                  } else {
                    this.caseService.updateTubeMap(this.case.caseStatus);
                  }

                  this.CalcTotalBuild();

                  if (this.case.developmentInput.cI_Dev_DoYouOwnTheProperty) {
                    this.CalcTotalPurchaseCostsOwning();
                  } else {
                    this.CalcTotalPurchaseCostsNotOwning();
                  }

                  //External links object initialisation
                  this.newExternalLink = this.initializeNewExternalLink();
                }

                this.extracted();
              } else if ((this.$rootScope as any).loginRedirectPath.includes("/casedashboard")) {
              } else {
                // If no case is returned, this could be that the logged in user has been removed from the case
                // - only do this if there is a logged in user, otherwise let the routing sort out where the redirect should go
                if ((this.$rootScope as any).selectedUser) {
                  this.$location.path("/dashboard");
                }
              }
            });
        })
        .catch((error) => {
          this.$location.path("/dashboard");
        })
        .finally(() => {
          this.dataLoading = false;
        });
    }
    this.updateCaseLandingSeenState();

    //Tour & Guidance logic
    let cookieTourStep = this.$cookies.get("tourStepPreapp");
    if (cookieTourStep) {
      this.tourState.tourStep = cookieTourStep;
    }
    $rootScope.$on("guidanceStateChanged", (event: ng.IAngularEvent) => {
      this.updateGuidanceState();
    });
    this.updateGuidanceState();
    this.getAppName();

    this.getLenderCount();

    this.referrerOptions = this.selectListService.GetReferrerOptions();
    this.locationOptions = this.selectListService.GetLocations();
  }

  private async extracted() {
    let currentUser;
    this.odataHelper
      .getOne(this.applicationUserCrudClient, {
        filter: { id: { eq: await this.indexService.currentUserId } },
        select: {
          isOrganisationAdmin: true,
          temporaryAccount: true,
          phoneNumber: true,
        },
      })
      .then((response) => {
        currentUser = response;
        this.currentPhoneNumber = this.requestAssistancePhoneNumber = currentUser.phoneNumber;
        // doesn't use cookies to get updated subscription status
        this.roleService.isOrganiationAdminUser().then((isOrgAdmin) => {
          this.isAdminBroker = isOrgAdmin;
        });
      });

    this.checkForAdmin();
    this.checkForBroker();
    this.checkForLender();
    this.checkIfOnlyBroker();
    this.checkForClient();
    this.updateRequestAssitanceCaseNoteMessage();

    const currentUserId = await this.indexService.currentUserId;
    this.newTeamMember = this.initializeNewTeamMember(currentUserId);
    this.newNote = this.initializeNewCaseNote(currentUserId);
    this.newComparable = this.initializeNewComparable();

    this.clientAccountAccessCheck();
  }

  updateGuidanceState() {
    this.guidanceCheckbox = this.$cookies.get("guidance") === "on" || this.$cookies.get("guidance") === undefined;

    // Update tour settings
    const tourEnabled = this.$cookies.get("tourEnabledPreapp");
    if ((tourEnabled == "true" || tourEnabled === undefined) && this.guidanceCheckbox) {
      this.tourEnabled = true;
    } else {
      this.tourEnabled = false;
    }
  }

  getTubeMapValue(): number {
    return this.caseService.getTubeMap();
  }

  closeModal(test: number) {
    this.message = false;
  }

  /**
   * Process the Accept/Cancel Application button being clicked
   */
  acceptCancelTerms() {
    this.caseLenderClient
      .applyToLender(this.selectedCaseLender.caseId, this.selectedCaseLender.id, true)
      .then((response) => {
        this.selectedCaseLender.caseLenderState = response.caseLenderState;
        this.caseLenders = this.caseLenders.filter((lender) => lender.id != this.selectedCaseLender.id);
        this.caseLenders.push(this.selectedCaseLender);
      })
      .finally(() => {
        this.messageContent = "Thank you for submitting an application with this lender.";
        this.message = true;
      });

    this.showApplyTsAndCs = false;
  }

  turnOffGuidance() {
    this.guidanceCheckbox = false;
    var expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    this.$cookies.put("guidance", "off", { expires: expiryDate });
    this.$rootScope.$broadcast("guidanceStateChanged");
  }

  getGuidanceSwitchState() {
    if (!this.$cookies.get("guidance")) {
      this.guidanceCheckbox = true;
    } else if (this.$cookies.get("guidance") === "on") {
      this.guidanceCheckbox = true;
    } else if (this.$cookies.get("guidance") === "off") {
      this.guidanceCheckbox = false;
    } else {
      this.guidanceCheckbox = true;
    }
    return this.guidanceCheckbox;
  }

  recordGuidanceCookie() {
    var guidanceSwitchState: string;
    var expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    if (this.guidanceCheckbox == true) {
      guidanceSwitchState = "on";
    } else {
      guidanceSwitchState = "off";
    }
    this.$cookies.put("guidance", guidanceSwitchState, { expires: expiryDate });
    this.$rootScope.$broadcast("guidanceStateChanged");
  }

  go(path): void {
    this.$location.path(path);
  }

  backToClientSearches(): void {
    (this.$rootScope as any).clientUsernameBeingViewed = this.case.developmentInput.ownerUser;
    this.authService.clearSelectedNavMenuAndFilterStorageData();
    this.go("/userdashboard");
  }

  async clientAccountAccessCheck(): Promise<void> {
    if (this.$cookies.get("access_token")) {
      const response = await this.caseMemberClient.fetchByCaseId(this.$routeParams.CaseId);
      const currentUserId = await this.indexService.currentUserId;
      const currentUserName = (await this.indexService.currentUser).userName;
      this.shareholders = response.find((x) => x.userId == currentUserId);
      this.primaryShareholder = response.find((x) => x.isPrimary == true);

      if (
        (currentUserName !== this.case.developmentInput.ownerUser && !this.shareholders) ||
        (currentUserName !== this.case.developmentInput.ownerUser && this.isAdmin)
      ) {
        this.clientUsernameBeingAccessed = this.case.developmentInput.ownerUser;
      }
    }
  }

  paymentStatusClose() {
    this.go("/casedashboard/" + this.$routeParams.CaseId);
    this.paymentStatus = "";
  }

  carriageReturnCheck(event) {
    if (event.key === "Enter") {
      let position = event.target.selectionStart;
      if (this.case.caseOverview) {
        this.case.caseOverview = [
          this.case.caseOverview.slice(0, position),
          "\n",
          this.case.caseOverview.slice(position),
        ].join("");

        setTimeout(() => {
          event.target.setSelectionRange(position + 1, position + 1);
        }, 0);
      } else {
        this.case.caseOverview = "\n";
      }
    }
  }

  toggleAccordion(id: number) {
    if (!this.accordionShow[id]) {
      this.accordionShow[id] = true;
    } else {
      this.accordionShow[id] = !this.accordionShow[id];
    }
  }

  formChanged(): void {
    (this.$rootScope as any).formSaved = false;
  }
  checkForAdmin(): void {
    this.dataLoading = true;
    this.roleService
      .isAdminUser()
      .then((response) => {
        this.isAdmin = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkForLender(): void {
    this.dataLoading = true;
    this.roleService
      .isLenderUser()
      .then((response) => {
        this.isLender = response;
        if (this.isLender) {
          this.caseLenderClient.fetchCaseLender(this.case.id).then((response) => {
            this.lenderDetails = response;
            this.isInActiveLender = response.isLenderInActive;
          });
        } else {
          if (this.case.developmentInput.selectedResults.length > 0) {
            this.lenderClient.getSelectedLendersName(this.case.developmentInput.selectedResults).then((response) => {
              this.selectedLendersText = response.lendersName;
              if (this.case.caseStatus == CaseStatusEnum.NewCase) {
                this.shortListedLendersId = response.lendersId;
              }
            });
            this.lenderClient.getShortlistedLendersName(this.case.developmentInput.selectedResults).then((response) => {
              this.shortlistedLendersText = response.lendersName;
              if (this.case.caseStatus != CaseStatusEnum.NewCase) {
                this.shortListedLendersId = response.lendersId;
              }
            });
          }
        }
        this.getBrokerUsers();
        this.checkIfUserIsInvited();
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkIfOnlyBroker() {
    this.dataLoading = true;
    this.roleService
      .isBroker()
      .then((response) => {
        this.IsOnlyBroker = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkForBroker(): void {
    this.dataLoading = true;
    this.roleService
      .isBrokerOrABove()
      .then((response) => {
        this.isBroker = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  checkForClient(): void {
    this.dataLoading = true;
    this.roleService
      .isClientUser()
      .then((response) => {
        this.isClient = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  // Gets the List of brokers belonging to broker organisation for admin or broker, and broker email to client or lender.
  getBrokerUsers(): void {
    this.dataLoading = true;
    if ((this.isAdmin || this.isBroker) && this.case.brokerOrganisationId) {
      this.organisationClient
        .getAllOrganisationMembers(this.case.brokerOrganisationId)
        .then((response) => {
          if (this.case.brokerUserId != null) {
            this.caseBrokerUser = response.find((x) => x.id == this.case.brokerUserId);
            this.brokerPreferredContact = this.caseBrokerUser?.phoneNumber;
          }
          this.brokerUsers = response.filter((x) => x.subscriptionStatus > 0 || x.isOrganisationAdmin);
        })
        .finally(() => {
          this.dataLoading = false;
        });
    } else if (this.case.brokerUserId != null && !this.isAdmin && !this.isBroker) {
      this.odataHelper
        .getOne(this.applicationUserCrudClient, {
          filter: { id: { eq: this.case.brokerUserId } },
          select: { email: true },
        })
        .then((response) => {
          this.brokerEmail = response.email;
        })
        .finally(() => {
          this.dataLoading = false;
        });
    }
  }

  async afterSetPasswordContinue() {
    //User needs to be logged out and logged in again
    if (this.$cookies.get("access_token")) {
      this.authService.logout(false);
    }
    this.authService
      .newLogin((await this.indexService.currentUser).email, this.password, "CC022EBE67BE0424EA2A6548B062D2D71")
      .then((response) => {
        let expiry: Date = response;
      });

    this.showSetPasswordModal = false;
  }

  saveLink(link: ExternalLinks): void {
    this.dataLoading = true;

    this.externalLinksClient
      .addUpdate(this.newExternalLink)
      .then((response) => {
        this.case.links.push(response);

        this.newExternalLink = this.initializeNewExternalLink();

        this.externalLinkForm.$setPristine();
        this.externalLinkForm.$setUntouched();
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  removeLink(link: ExternalLinks): void {
    this.dataLoading = true;
    this.externalLinksClient
      .markAsDeleted(link.id)
      .then((response) => {
        let index = this.case.links.indexOf(link);
        this.case.links.splice(index, 1);
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  saveTeamMember(teamMember: TeamMember) {
    this.newTeamMember.website = this.newTeamMember.website == "https://" ? "" : this.newTeamMember.website;
    this.teamMemberClient.addUpdate(this.newTeamMember).then((response) => {
      this.case.teamMembers.push(response);
      this.showAdd = false;
    });
  }

  addTeamMemberPopUp() {
    this.indexService.currentUserId.then((userId) => {
      this.showAdd = true;
      this.newTeamMember = this.initializeNewTeamMember(userId);
    });
  }

  resetTeamMember() {
    this.indexService.currentUserId.then((userId) => {
      this.teamMemberForm.$setPristine();
      this.teamMemberForm.$setUntouched();
      this.showAdd = false;
      this.newTeamMember = this.initializeNewTeamMember(userId);
    });
  }

  deleteTeamMember(): void {
    this.teamMemberClient.markAsDeleted(this.confirmDeleteTeamMember.id).then((response) => {
      let index = this.case.teamMembers.indexOf(this.confirmDeleteTeamMember);
      this.case.teamMembers.splice(index, 1);
    });
    this.confirmDeleteTeamMember = {} as TeamMember;
    this.showDelete = false;
  }

  updateTeamMember(teamMember: TeamMember): void {
    this.editTeamMember = teamMember;
    this.tempTeamMember = { ...this.editTeamMember };
    this.editTeamMember.website = this.editTeamMember.website ? this.editTeamMember.website : "https://";
    this.showEdit = true;
  }

  saveUpdatedTeamMember(teamMember: TeamMember): void {
    this.editTeamMember.website = this.editTeamMember.website == "https://" ? "" : this.editTeamMember.website;
    this.editTeamMember.case = this.editTeamMember.case ?? null;
    this.editTeamMember.user = this.editTeamMember.user ?? null;
    this.teamMemberClient
      .addUpdate(this.editTeamMember)
      .then((response) => {
        this.case.teamMembers = this.case.teamMembers.filter((member) => member.id != this.editTeamMember.id);
        this.case.teamMembers.push(response);
      })
      .finally(() => {
        this.showEdit = false;
      });
  }

  cancelUpdateTeamMember() {
    this.showEdit = false;
    this.case.teamMembers = this.case.teamMembers.filter((member) => member.id != this.tempTeamMember.id);
    this.case.teamMembers.push(this.tempTeamMember);
  }

  deleteConfirmTeamMember(teamMember: TeamMember) {
    this.showDelete = true;
    this.confirmDeleteTeamMember = { ...teamMember };
  }

  saveComparable(comparable: ComparableProperty): void {
    this.newComparable.url = this.newComparable.url == "https://" ? "" : this.newComparable.url;
    this.comparablePropertyClient.addUpdate(this.newComparable).then((response) => {
      this.case.comparables.push(response);
      this.newComparable = this.initializeNewComparable();
      this.comparableForm.$setPristine();
      this.comparableForm.$setUntouched();
      this.showAdd = false;
    });
  }

  resetComparable() {
    this.newComparable = this.initializeNewComparable();
    this.comparableForm.$setPristine();
    this.comparableForm.$setUntouched();
    this.showAdd = false;
  }

  deleteComparable(): void {
    this.comparablePropertyClient.markAsDeleted(this.confirmDeleteComparable.id).then((response) => {
      const index = this.case.comparables.indexOf(this.confirmDeleteComparable);
      this.case.comparables.splice(index, 1);
    });
    this.confirmDeleteComparable = {} as ComparableProperty;
    this.confirmationDelete = false;
  }

  updateComparable(comparable: ComparableProperty): void {
    this.editComparable = comparable;
    this.tempComparable = { ...this.editComparable };
    this.editComparable.url = this.editComparable.url ? this.editComparable.url : "https://";
    this.showEdit = true;
  }

  saveUpdatedComparable(comparable: ComparableProperty): void {
    this.editComparable.url = this.editComparable.url == "https://" ? "" : this.editComparable.url;
    this.comparablePropertyClient
      .addUpdate(this.editComparable)
      .then((response) => {
        this.case.comparables = this.case.comparables.filter((member) => member.id != this.editComparable.id);
        this.case.comparables.push(response);
      })
      .finally(() => {
        this.showEdit = false;
      });
  }

  cancelDelete() {
    this.confirmationDelete = false;
  }

  deleteConfirmationMessage(row) {
    this.confirmationDelete = true;
    this.confirmDeleteComparable = { ...row };
  }

  cancelUpdateComparable() {
    this.showEdit = false;
    this.case.comparables = this.case.comparables.filter((member) => member.id != this.tempComparable.id);
    this.case.comparables.push(this.tempComparable);
  }

  rejectOrWithdrawConfirmation(rejectorwithdraw: string) {
    rejectorwithdraw === "Withdraw" ? (this.showWithdraw = true) : (this.showReject = true);
  }

  goToCaseDashboard() {
    this.$location.path("/casedashboard/" + this.case.id);
  }

  updateCaseLandingSeenState() {
    this.caseLandingSeen = this.$cookies.get("caseLandingDontShowAgain") === "yes";
  }

  caseLandingSeenClicked() {
    this.caseLandingSeen = true;
    var expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    this.$cookies.put("caseLandingDontShowAgain", "yes", {
      expires: expiryDate,
    });
  }

  viewResults() {
    this.$location.path("/results/" + this.case.developmentInputId + "/" + this.case.id);
  }

  CreateDeveloperExperience() {
    this.$location.path("/devexperience/" + this.case.id + "/-1");
  }
  EditDeveloperExperience() {
    if (this.case.developmentExperienceId) {
      this.$location.path("/devexperience/" + this.case.id + "/" + this.case.developmentExperienceId);
    } else {
      this.CreateDeveloperExperience();
    }
  }

  EditProfiles() {
    if (this.case.developmentExperienceId) {
      this.$location.path("/profiles/" + this.case.id + "/" + this.case.developmentExperienceId);
    } else {
      this.CreateDeveloperExperience();
    }
  }

  UpdateDeveloperInformation() {
    this.$location.path("/criteriaappraisal/" + this.case.id + "/" + this.case.developmentInput.id);
  }

  EditDeveloperSchedule() {
    this.$location.path("/devschedule/" + this.case.id + "/" + this.case.developmentInput.id);
  }

  doRenameSearch() {
    this.developmentInputCrudClient
      .patch({ id: this.case.developmentInput.id, searchName: this.case.developmentInput.searchName })
      .then((response) => {
        this.toggleEditSearchName = false;
      });
  }

  saveCase(): ng.IPromise<number> {
    this.dataLoading = true;
    let defer = this.$q.defer<number>();
    this.caseCrudClient
      .patch({
        ...this.case,
        developmentInput: undefined,
        caseNotes: undefined,
      })
      .then((response) => {
        defer.resolve(response.id);
        return response;
      })
      .catch((response) => {
        defer.reject(response);
      })
      .finally(() => {
        this.dataLoading = false;
      });
    return defer.promise;
  }

  delete() {
    this.dataLoading = true;
    this.caseService
      .delete(this.case.id)
      .then((response) => {
        if (response) {
          this.objects.splice(this.objects.indexOf(this.case), 1);
          this.caseForm.$setPristine();
          delete this.case;
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  getdevelopmentinput(id: number) {
    this.dataLoading = true;
    this.odataHelper
      .getOne(this.developmentInputCrudClient, {
        filter: { id: { eq: id } },
        expand: { selectedResults: true },
      })
      .then((response) => {
        this.case.developmentInput = response;
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  //File upload

  //calculateFilesForThisModule() {
  //  this.fileUploadPlaning = this.fileUpload.filter(file => file.Module === ModuleEnum.Planning);
  //this.fileUploadTeam = this.fileUpload.filter(file => file.Module === ModuleEnum.ProfessionalTeam);
  //this.fileUploadProperties = this.fileUpload.filter(file => file.Module === ModuleEnum.ComparableProperties);
  //}

  calculateTotalFiles(filter: number) {
    if (this.fileUpload) {
      this.total = this.fileUpload.filter((item) => item.module === filter).length;
    }
    return this.total;
  }

  calculateTotalFilesRemoving(filter: number) {
    if (this.fileUpload) {
      this.total = this.fileUpload.filter((item) => item.module != filter).length;
    }
    return this.total;
  }

  onFileSelect(files, moduleSelected) {
    let module = ModuleEnum.Case;
    if (moduleSelected === "Planning") {
      module = ModuleEnum.Planning;
    } else if (moduleSelected === "teammember") {
      module = ModuleEnum.ProfessionalTeam;
    } else if (moduleSelected === "properties") {
      module = ModuleEnum.ComparableProperties;
    } else if (moduleSelected === "images") {
      module = ModuleEnum.Images;
    }

    this.openModal = false;

    if (files.length > 0) {
      //if case has no id it must be saved first
      if (this.case.id < 1) {
        this.dataLoading = true;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { attachments, developmentInput, ...onlyCase } = this.case;
        this.caseCrudClient
          .patch(onlyCase)
          .then((response) => {
            //Potentially unsafe cast
            this.case = response as Expand<
              Case,
              {
                readonly attachments: true;
                readonly developmentInput: { readonly selectedResults: true };
                readonly links: true;
                readonly caseNotes: { readonly user: true };
                readonly teamMembers: true;
                readonly comparables: true;
              }
            >;
            this.onFileSelect(files, module); //call itself and then exit as should now be saved so should be able to run
            return;
          })
          .catch((e) => {})
          .finally(() => {
            this.dataLoading = false;
            this.openModal = false;
          });
        //return;
      }
      this.fileAttachmentHelper
        .UploadFileLstInSync(files, this.uploadingFiles, this.case.id, this.fileUpload, module)
        .finally(() => {
          this.openModal = false;
          this.dataLoading = false;
        });
    }
  }

  downloadFile(file: FileAttachment) {
    this.dataLoading = true;
    this.dealFileAttachmentClient
      .getAmazonFileAccessUri(file.fileLocation)
      .then((uri) => {
        this.$window.open(uri);
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  downloadFilesAsZip(files: FileAttachment) {
    var keys: string[] = [];
    for (var file in files) {
      if (files[file].FileLocation) {
        keys.push(files[file].FileLocation);
      }
    }
  }

  deleteFile(file: FileAttachment) {
    this.case.attachments.splice(this.case.attachments.indexOf(file), 1);
    this.fileAttachmentClient.markAsDeleted(file.id).then((result) => {}); //remove on the server
  }

  renameFile(file: FileAttachment) {
    if (this.renamingFile === undefined) {
      // if renaming this file will dirty the case, we'll want to set it back to pristine when we're done.
      // this.renamingFileDirties = !$scope.caseForm.$dirty;
      this.renamingFile = file;
    } else {
      delete this.renamingFile;
    }
  }
  renamingFileComplete(file: FileAttachment) {
    this.dataLoading = true;
    file.case = file.case ?? null;
    file.user = file.user ?? null;
    file.tempURL = file.tempURL ?? "";
    file.tempUploadURL = file.tempUploadURL ?? "";
    file.userName = file.userName ?? "";

    this.fileAttachmentClient
      .fileRename(file)
      .then((response) => {
        file.tempURL = response.tempURL;
      })
      .finally(() => {
        this.dataLoading = false;
      });
    delete this.renamingFile;
  }

  renamingLinkCompleted(link: ExternalLinks) {
    this.dataLoading = true;
    this.externalLinksClient
      .addUpdate(link)
      .then((response) => {
        link.link = response.link;
      })
      .finally(() => {
        this.dataLoading = false;
      });
    delete this.renamingFile;
  }

  //TODO: this will probably need to be deleted once apply button is put on lendings page
  ProcessApplication() {
    let result = this.$location.path("/payment/" + this.case.id);

    if (result) {
      this.setApplyStatus();
    }

    this.showTsAndCsForm = true;
    this.showTsAndCs = true;
  }

  //TOUR

  tourNext(): void {
    this.tourState.tourStep++;
    this.$cookies.put("tourStep", this.tourState.tourStep);
  }
  tourBack(): void {
    this.tourState.tourStep--;
    this.$cookies.put("tourStep", this.tourState.tourStep);
  }

  tourSkip(): void {
    this.tourEnabled = false;
    this.$cookies.put("tourEnabledPreapp", "false");
    this.$cookies.remove("tourStep");
  }

  startTour(): void {
    this.tourState.tourStep = 1;
    this.tourState.tourTotalSteps = 0;
    this.$cookies.put("tourStep", this.tourState.tourStep);
    this.tourEnabled = true;
    this.$cookies.put("tourEnabledPreapp", "true");
  }

  removeNote(note: CaseNote): void {
    this.dataLoading = true;
    this.caseNoteClient
      .markAsDeleted(note.id)
      .then((response) => {
        let index = this.case.caseNotes.findIndex((caseNote) => caseNote.id === note.id);
        if (index !== -1) {
          this.case.caseNotes.splice(index, 1);
        }
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  saveNote() {
    this.dataLoading = true;

    const currentUserIdPromise = this.indexService.currentUserId;

    this.caseNoteClient
      .addUpdate(this.newNote)
      .then((response) => {
        this.case.caseNotes.push(response as Expand<CaseNote, { user: true }>);
        return currentUserIdPromise;
      })
      .then((currentUserId) => {
        this.newNote = this.initializeNewCaseNote(currentUserId);
        this.caseForm.$setPristine();
        this.caseForm.$setUntouched();
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  statusMap = [
    { status: 0, label: "New Case" },
    { status: 1, label: "Pre App" },
    { status: 2, label: "Decision in Principle" },
    { status: 3, label: "App Made" },
    { status: 4, label: "Credit Approval" },
    { status: 5, label: "With Professionals" },
    { status: 6, label: "Completed" },
    { status: 7, label: "Dormant" },
    { status: 9, label: "Submitted To Lenders Pending Review" },
  ];

  async setStatus(newCaseStatus: CaseStatusEnum) {
    let statusText = this.statusMap.find((status) => {
      return status.status === newCaseStatus;
    });
    this.dataLoading = true;
    try {
      await this.caseClient.setStatusOnCase(this.case.id, newCaseStatus);
      this.caseService.updateTubeMap(newCaseStatus);
      const userId = await this.indexService.currentUserId;
      const caseNote = this.initializeNewCaseNote(userId);
      caseNote.noteText = "Status changed to: " + statusText.label;
      this.caseNoteClient.addUpdate(caseNote).then((caseNoteResponse) => {
        //Potentially unsafe cast
        this.case.caseNotes.push(caseNoteResponse as Expand<CaseNote, { user: true }>);
      });
    } finally {
      this.dataLoading = false;
    }
  }

  markSectionAsComplete(propertyName: string, noteText: string) {
    this.case[propertyName] = !this.case[propertyName];
    // TODO JNG this should probably not save the entire case.
    this.dataLoading = true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { attachments, developmentInput, links, caseNotes, comparables, teamMembers, ...patchCase } = this.case;
    this.caseCrudClient
      .patch(patchCase)
      .then(() => {
        this.indexService.currentUserId.then((userId) => {
          const caseNote = this.initializeNewCaseNote(userId);
          caseNote.noteText = noteText + " marked as " + (this.case[propertyName] ? "complete" : "incomplete") + ".";
          this.caseNoteClient.addUpdate(caseNote).then((caseNoteResponse) => {
            //Potentially unsafe cast
            this.case.caseNotes.push(caseNoteResponse as Expand<CaseNote, { user: true }>);
          });
        });
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  showMessage(message: string) {
    this.messageContent = message;
  }

  requestEmail(reason): void {
    this.showRequestEmailForm = true;
    this.requestMessageReason = reason;
    this.message = true;
    this.messageContent = "";
  }

  sendRequestEmail() {
    this.showRequestEmailForm = false;
    this.sendingMessage = true;
    this.dataLoading = true;
    this.accountClient
      .requestAssistanceReview(
        this.requestMessageReason,
        this.case.id,
        ProductFamilyEnum.None,
        this.requestAssistancePhoneNumber,
      )
      .then(async (response) => {
        this.showMessage(
          `${this.appName} have been notified that you require assistance and will be in touch shortly to help.`,
        );

        let caseNote = {
          caseId: this.case.id,
          userId: await this.indexService.currentUserId,
          noteText: "You have requested " + this.requestMessageReason + ".",
          // expandNote: false,
        } as CaseNote;
        this.caseNoteClient.addUpdate(caseNote).then((caseNoteResponse) => {
          //Potentially unsafe cast
          this.case.caseNotes.push(caseNoteResponse as Expand<CaseNote, { user: true }>);
        });
      })
      .catch((error) => {
        this.showMessage("Sorry, something went wrong while sending your email. Please try again.");
      })
      .finally(() => {
        this.sendingMessage = false;
        this.dataLoading = false;
        this.requestAssistancePhoneNumber = this.currentPhoneNumber;
      });
  }

  /** Opens the Terms and Conditions popup when the Submit to Lenders button is clicked*/
  showTermsAndConditionsForBorrower() {
    this.showApplyTsAndCs = true;
    this.requestMessageReason = "a review";
    this.showTsAndCs = true;
  }

  /** Request a Review button clicked */
  requestReview() {
    this.showTsAndCsForm = false;
    this.sendingMessage = true;
    this.dataLoading = true;
    this.requestMessageReason = "a review";
    this.caseClient
      .requestReview(this.case.id, this.currentPhoneNumber, this.requestMessageReason)
      .then((response) => {
        this.case.caseStatus = response.caseState;
        this.showMessage(
          `Thank you for accepting the terms and conditions. ${this.appName} have been notified that you require a review and will be in touch shortly to help.`,
        );
      })
      .catch((error) => {
        this.showMessage("Sorry, something went wrong while sending your email. Please try again.");
      })
      .finally(() => {
        this.sendingMessage = false;
        this.dataLoading = false;
        this.showApplyTsAndCs = false;
      });
  }

  /** Opens the Terms and Conditions popup when the Submit to Lenders HoT button is clicked (borrower/broker) */
  showTermsAndConditions() {
    this.dataLoading = true;
    this.lenderClient
      .getShortlistedLendersInfoForSubmitToLenders(
        LenderProductTypeEnum.DevelopmentFinance,
        false,
        this.shortListedLendersId,
      )
      .then((response) => {
        this.lendersDetailsForSubmittoLenders = response;
      })
      .finally(() => {
        this.showTsAndCs = true;
        this.showTsAndCsForm = true;
        this.case.submitTsAndCs = false;
        this.invalidEmail = false;
        this.dataLoading = false;
      });
  }

  /** Submit button clicked (on Terms and Conditions popup) */
  submitToLenders() {
    this.showTsAndCsForm = false;
    this.sendingMessage = true;
    this.dataLoading = true;

    this.caseCrudClient
      .patch({
        ...this.case,
        developmentInput: undefined,
        caseNotes: undefined,
      })
      .then(() => {
        if (this.case.caseStatus == CaseStatusEnum.ReadyToReSubmit) {
          this.caseClient
            .reSubmitForHoTs(
              this.case.id,
              this.brokerCommission,
              this.brokerPreferredContact,
              this.isBrokerPhoneNumberUpdated,
              this.lendersDetailsForSubmittoLenders,
            )
            .then((response) => {
              this.case.caseStatus = response.caseState;
              this.showMessage("This case has been re-submitted to Lenders to request a Decision in Principle.");
              this.isSubmittedToLenders = true;
            })
            .catch((error) => {
              this.showMessage("Sorry, something went wrong. Please try again.");
            })
            .finally(() => {
              this.sendingMessage = false;
              this.dataLoading = false;
              this.caseService.updateTubeMap(this.case.caseStatus);
            });
        } else {
          this.caseClient
            .submitForHoTs(
              this.case.id,
              this.brokerCommission,
              this.brokerPreferredContact,
              this.isBrokerPhoneNumberUpdated,
              this.lendersDetailsForSubmittoLenders,
            )
            .then((response) => {
              this.case.caseStatus = response.caseState;
              this.showMessage("You have requested a Decision in Principle from each lender.");
              this.isSubmittedToLenders = true;
            })
            .catch((error) => {
              this.showMessage("Sorry, something went wrong. Please try again.");
            })
            .finally(() => {
              this.sendingMessage = false;
              this.dataLoading = false;
              this.caseService.updateTubeMap(this.case.caseStatus);
            });
        }
      });
  }

  setApplyStatus() {
    this.dataLoading = true;
    this.showStatusMessage = true;
    this.caseClient
      .setStatusOnCase(this.case.id, CaseStatusEnum.Applied)
      .then(async (statusUpdateResponse) => {
        this.case.caseStatus = CaseStatusEnum.Applied;
        let caseNote = {
          caseId: this.case.id,
          userId: await this.indexService.currentUserId,
          noteText: "User has moved application to app made stage",
          // expandNote: false,
        } as CaseNote;
        this.caseNoteClient.addUpdate(caseNote).then((caseNoteResponse) => {
          //Potentially unsafe cast
          this.case.caseNotes.push(caseNoteResponse as Expand<CaseNote, { user: true }>);
        });
      })
      .catch((error) => {})
      .finally(() => {
        this.dataLoading = false;
      });
  }

  allFormsComplete(): boolean {
    if (this.case) {
      if (
        this.case.caseOverviewComplete &&
        this.case.developerExperienceComplete &&
        this.case.developmentAppraisalComplete &&
        this.case.developmentScheduleComplete
      ) {
        return true;
      } else {
        return false;
      }
    }
  }

  //case overview
  editCaseOverview() {
    //take a temp backup of what is in case overview in case they hit cancel
    this.caseOverviewTempBackup = this.case.caseOverview;
    this.$location.path("/caseoverview/" + this.case.id);
  }

  //Planning Module
  editPlanning() {
    //take a temp backup of what is in Planning Module in case they hit cancel
    this.planningURLTempBackup = this.case.planningURL;
    this.planningLocalAuthorityTempBackup = this.case.planningLocalAuthority;
    this.planningReferenceTempBackup = this.case.planningReference;
    this.planningDescriptionTempBackup = this.case.planningDescription;
    this.$location.path("/planning/" + this.case.id);
    this.planningURLTempBackup = this.case.planningURL;
    this.planningLocalAuthorityTempBackup = this.case.planningLocalAuthority;
    this.planningReferenceTempBackup = this.case.planningReference;
    this.planningDescriptionTempBackup = this.case.planningDescription;
    this.$location.path("/planning/" + this.case.id);
  }

  //Comparables Module
  editComparableProperties() {
    this.$location.path("/comparableproperties/" + this.case.id);
  }

  editProfessionalTeam() {
    this.$location.path("/teammember/" + this.case.id);
  }

  returnToCase(saveBefore: boolean): void {
    if (saveBefore) {
      this.saveCase().then((success) => {
        this.planningURLTempBackup = this.case.planningURL;
        this.planningLocalAuthorityTempBackup = this.case.planningLocalAuthority;
        this.planningReferenceTempBackup = this.case.planningReference;
        this.planningDescriptionTempBackup = this.case.planningDescription;
        this.$location.path("/casedashboard/" + this.case.id);
      });
    } else {
      this.case.planningURL = this.planningURLTempBackup;
      this.case.planningLocalAuthority = this.planningLocalAuthorityTempBackup;
      this.case.planningReference = this.planningReferenceTempBackup;
      this.case.planningDescription = this.planningDescriptionTempBackup;
      this.$location.path("/casedashboard/" + this.case.id);
    }
    (this.$rootScope as any).formSaved = true;
  }

  async openSendToBorrower(contextToShare: number) {
    this.shareContext = contextToShare;
    this.shareSuplId = 0;
    if ((await this.indexService.currentUser).userName !== this.case.developmentInput.ownerUser) {
      this.userFirstName = "";
    } else {
      this.odataHelper
        .getOne(this.applicationUserCrudClient, {
          filter: { id: { eq: await this.indexService.currentUserId } },
          select: {
            firstName: true,
          },
        })
        .then((response) => {
          this.userFirstName = response.firstName;
        });
    }

    this.constructShareNoteMessage();

    this.caseMemberClient.fetchCaseMembersWithAccess(this.case.id).then((response: CaseMember[]) => {
      this.caseMembersWithAccess = response;

      this.showShare = true;
    });
  }

  sendToBorrower() {
    this.dataLoading = true;
    this.caseClient
      .sendNote(
        this.selectedClientToShareWith.firstName,
        this.selectedClientToShareWith.surname,
        this.selectedClientToShareWith.email,
        this.shareNote,
        this.case.id,
        this.shareContext,
        this.shareSuplId,
        this.case.developmentExperienceId,
      )
      .then((success) => {
        this.showShare = false;
        this.dataLoading = false;
        this.showModuleShareConfirmation = true;
      });
  }

  closeModuleShareConfirmationModal() {
    this.selectedClientToShareWith = null;
    this.showModuleShareConfirmation = false;
  }

  CalcTotalPurchaseCostsNotOwning(): number {
    var res: number = 0;
    if (this.case.developmentInput.cI_Dev_OrigPP) {
      res += Number(this.case.developmentInput.cI_Dev_OrigPP);
    }
    if (this.case.developmentInput.cI_Dev_SDLT) {
      res += Number(this.case.developmentInput.cI_Dev_SDLT);
    }
    if (this.case.developmentInput.dI_PurchaseAgentFees) {
      res += Number(this.case.developmentInput.dI_PurchaseAgentFees);
    }
    if (this.case.developmentInput.dI_PurchaseLegalFees) {
      res += Number(this.case.developmentInput.dI_PurchaseLegalFees);
    }
    if (this.case.developmentInput.dI_PurchaseOtherFees) {
      res += Number(this.case.developmentInput.dI_PurchaseOtherFees);
    }
    this.totalPurchaseCostsNotOwning = res;
    return res;
  }

  CalcTotalPurchaseCostsOwning(): number {
    var res: number = 0;
    if (this.case.developmentInput.cI_Dev_OrigPP) {
      res += Number(this.case.developmentInput.cI_Dev_OrigPP);
    }
    if (this.case.developmentInput.cI_Dev_SDLT) {
      res += Number(this.case.developmentInput.cI_Dev_SDLT);
    }
    if (this.case.developmentInput.dI_PurchaseAgentFees) {
      res += Number(this.case.developmentInput.dI_PurchaseAgentFees);
    }
    if (this.case.developmentInput.dI_PurchaseLegalFees) {
      res += Number(this.case.developmentInput.dI_PurchaseLegalFees);
    }
    if (this.case.developmentInput.dI_PurchaseOtherFees) {
      res += Number(this.case.developmentInput.dI_PurchaseOtherFees);
    }
    this.totalPurchaseCostsOwning = res;
    return res;
  }

  CalcTotalBuild(): number {
    var res: number = this.CalcAdditionalBuild();
    if (this.case.developmentInput.cI_Dev_BuildCosts) {
      res += Number(this.case.developmentInput.cI_Dev_BuildCosts);
    }
    var res: number = this.CalcAdditionalBuild();
    if (this.case && this.case.developmentInput.cI_Dev_BuildCosts) {
      res += Number(this.case.developmentInput.cI_Dev_BuildCosts);
    }

    res += this.calcContingencyCost();
    this.totalBuild = res;
    return res;
  }

  calcContingencyCost(): number {
    var res: number = 0;
    if (this.case.developmentInput.cI_Dev_Contingency && this.case.developmentInput.cI_Dev_BuildCosts) {
      res = this.case.developmentInput.cI_Dev_Contingency * this.case.developmentInput.cI_Dev_BuildCosts;
      this.contingencyTotal = res;
      return res;
    }
    return res;
  }

  CalcAdditionalBuild(): number {
    var res: number = 0;
    if (this.case.developmentInput.dI_BreakDownBuildCosts) {
      if (this.case.developmentInput.cI_Dev_ProfPlanning) {
        res += Number(this.case.developmentInput.cI_Dev_ProfPlanning);
      }
      if (this.case.developmentInput.cI_Dev_ProfQS) {
        res += Number(this.case.developmentInput.cI_Dev_ProfQS);
      }
      if (this.case.developmentInput.dI_BuildProjectManag) {
        res += Number(this.case.developmentInput.dI_BuildProjectManag);
      }
      if (this.case.developmentInput.cI_Dev_S106CIL) {
        res += Number(this.case.developmentInput.cI_Dev_S106CIL);
      }
      if (this.case.developmentInput.dI_BuildMechEng) {
        res += Number(this.case.developmentInput.dI_BuildMechEng);
      }
      if (this.case.developmentInput.dI_BuildStrucEng) {
        res += Number(this.case.developmentInput.dI_BuildStrucEng);
      }
      if (this.case.developmentInput.dI_BuildPartyWall) {
        res += Number(this.case.developmentInput.dI_BuildPartyWall);
      }
      if (this.case.developmentInput.dI_BuildLandscaping) {
        res += Number(this.case.developmentInput.dI_BuildLandscaping);
      }
      if (this.case.developmentInput.dI_BuildWarranty) {
        res += Number(this.case.developmentInput.dI_BuildWarranty);
      }
      if (this.case.developmentInput.dI_BuildDemolition) {
        res += Number(this.case.developmentInput.dI_BuildDemolition);
      }
      if (this.case.developmentInput.dI_BuildOtherCosts) {
        res += Number(this.case.developmentInput.dI_BuildOtherCosts);
      }
    } else {
      if (this.case.developmentInput.cI_Dev_AdditionalOngoingCosts) {
        res += Number(this.case.developmentInput.cI_Dev_AdditionalOngoingCosts);
      }
    }
    this.additionalBuild = res;
    return res;
  }

  videotour() {
    this.showVideo = true;
  }

  videopause(id) {
    this.showVideo = false;
    let containerElement = document.getElementById(id);
    let iframe_tag = containerElement.querySelector("iframe");
    if (iframe_tag) {
      let iframeSrc = iframe_tag.src;
      iframe_tag.src = iframeSrc;
    }
  }

  addTeamRoleOption(e) {
    this.newTeamMember.teamRole = "";
    e.target.value = "";
  }

  editTeamRoleOption(e) {
    this.editTeamMember.teamRole = "";
    e.target.value = "";
  }

  EnumToString(item: ModuleEnum) {
    switch (item) {
      case 0:
        return "Case Overview";
      case 1:
        return "Developer Profile";
      case 2:
        return "Development Appraisal";
      case 3:
        return "Development Schedule";
      case 4:
        return "Planning";
      case 5:
        return "Professional Team";
      case 6:
        return "Comparable Properties";
      case 7:
        return "General";
      case 8:
        return "Track Record";
      case 9:
        return "Assets & Liabilities";
      case 10:
        return "Proof Of Income";
      case 11:
        return "Applicant Details";
      case 12:
        return "Pictures";
      default:
        return "General";
    }
  }

  gotoLendingPage() {
    (this.$rootScope as any).isLender = false;
    this.$location.path("/lending/" + this.case.id);
  }

  checkBrokerDeal() {
    return this.case?.brokerUserId != null && this.isClient ? true : false;
  }

  /*  gotoPaymentPage() {
              this.$location.path("/payment/" + this.case.id);
          }*/

  gotoHeadsOfTermsPage() {
    this.$location.path("/headsofterm/" + this.case.id);
  }

  /** Approve button clicked (This functionality has been removed from the process)
        approve() {
            this.dataLoading = true;
            this.caseService.approve(this.case.id).then((response) => {
                this.case.caseStatus = response.CaseState;
                this.caseService.updateTubeMap(response.CaseState);
                this.showMessage("Your case has been approved.");
                this.showStatusMessage = true;
            }).catch((error) => {
                this.showMessage("Sorry, something went wrong while approving your case. Please try again.");
            }).finally(() => {
                this.dataLoading = false;
            });;
        }*/

  setBrokerOrganisation(value: number) {
    // TODO JNG this should probably not save the entire case.
    this.dataLoading = true;
    this.case.brokerUserId = null;

    this.caseClient
      .setBrokerOrganisation(this.case.id, this.case.brokerOrganisationId)
      .then((response: CaseNote) => {
        //populating the users related to selected new organisation.
        this.getBrokerUsers();

        //Potentially unsafe cast
        this.case.caseNotes.push(response as Expand<CaseNote, { user: true }>);
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  setBrokerUser(value: string) {
    this.dataLoading = true;
    this.caseClient
      .setBrokerUser(this.case.id, this.case.brokerUserId)
      .then((response) => {
        //Potentially unsafe cast
        this.case.caseNotes.push(response as Expand<CaseNote, { user: true }>);
      })
      .finally(() => {
        this.dataLoading = false;
      });
  }

  goToLending() {
    this.$location.path("/lending/" + this.case.id);
    this.caseService.setIsProceed(false);
  }

  isShareNoteFormComplete(): boolean {
    if (!this.selectedClientToShareWith) {
      return false;
    }

    if (this.shareNote == "undefined" || this.shareNote == null || this.shareNote.length == 0) {
      return false;
    }

    return true;
  }

  constructShareNoteMessage() {
    var message: string;
    var messageStart: string = `Please take a look at the `;
    var messageEnd: string =
      ` section in your Smart Appraisal™ and complete as much as you can.\n\nIf you would like our help or want us to complete this module with you, please do give me a call on ` +
      this.currentPhoneNumber +
      `.`;

    switch (this.shareContext) {
      case 1: //overview
        message =
          `Please take a look at the case overview I have started for you and add to it where you can.\n\nThis section provides the lender with an overview about you, your team and your project.  Lenders approve just 1 in 4 applications due to poor presentation, so we need to make it as impactful as possible.\n\nIf you would like to call me so we can add the notes together, my number is ` +
          this.currentPhoneNumber +
          `.`;
        break;
      case 2: //dev experience
        this.shareSuplId = this.case.developmentExperienceId ? this.case.developmentExperienceId : -1;
        message = messageStart + `ownership` + messageEnd;
        break;
      case 3: //dev appraisal
        this.shareSuplId = this.case.developmentInput.id;
        message = messageStart + `development appraisal` + messageEnd;
        break;
      case 4: //schedule
        this.shareSuplId = this.case.developmentInput.id;
        message = messageStart + `development schedule` + messageEnd;
        break;
      case 5: //files
        message = `Please upload the supporting documents associated with your project.\n\nAdding supporting documents helps lenders make quicker and more reliable decisions.`;
        break;
      case 6: //planning module
        this.shareSuplId = this.case.developmentInput.id;
        message = messageStart + `planning section` + messageEnd;
        break;
      case 7: //Professional Team
        this.shareSuplId = this.case.developmentInput.id;
        message = messageStart + `professional team` + messageEnd;
        break;
      case 8: //comparable properties module
        message = messageStart + `comparable properties` + messageEnd;
        break;
      case 9: //profiles module
        message = messageStart + `profiles` + messageEnd;
        break;
    }

    this.shareNote = message;
  }

  /** Process the Heads of Terms button being clicked */
  headsOfTermsClicked() {
    sessionStorage.setItem("lenderTask", "terms");
    this.$location.path("/headsofterm/" + this.case.id + "/" + this.lenderDetails.id);
  }

  showAndHideExport() {
    this.showExport = !this.showExport;
  }

  /** Lender rejects the case*/
  rejectButtonClicked() {
    sessionStorage.setItem("lenderTask", "reject");
    this.$location.path("/headsofterm/" + this.case.id + "/" + this.lenderDetails.id);
  }

  withDrawButtonClicked() {
    sessionStorage.setItem("lenderTask", "withdraw");
    this.$location.path("/headsofterm/" + this.case.id + "/" + this.lenderDetails.id);
  }

  feedbackButtonClicked() {
    sessionStorage.setItem("lenderTask", "feedback");
    this.$location.path("/headsofterm/" + this.case.id + "/" + this.lenderDetails.id);
  }

  getAppName() {
    let lsd = sessionStorage.getItem("applicationName");
    if (lsd != null) {
      this.appName = lsd;
    } else {
      this.appName = "Brickflow";
    }
  }

  closeModalAndGoToDasboard() {
    this.showTsAndCs = false;
    this.authService.clearSelectedNavMenuAndFilterStorageData();
    this.$location.path("/userdashboard");
  }

  closeModalAndGoToDealForum() {
    this.showTsAndCs = false;
    this.$location.path("/lending/" + this.case.id);
  }

  async checkIfUserIsInvited() {
    //added to scope for directive
    const isInvited = await this.caseClient.isUserInvitedToCase(
      await this.indexService.currentUserId,
      this.$routeParams.CaseId,
    );

    const licenceData = await this.indexService.currentUserLicenseData;
    const subscriptionStatus = licenceData.subscriptionStatus;

    // if user has no active subscription (and are not a lender or admin) then they should be redirected back to the dashboard
    if (
      subscriptionStatus != LicenseMasterStatusEnum.PaidUp &&
      subscriptionStatus != LicenseMasterStatusEnum.PreCancel &&
      subscriptionStatus != LicenseMasterStatusEnum.PaymentProcessing &&
      !isInvited &&
      !this.isAdmin &&
      !this.isLender
    ) {
      this.$location.path("/dashboard");
      return;
    }

    (this.$rootScope as any).isInvitedToCase = isInvited;
    if (isInvited) {
      this.caseMemberClient.fetchByCaseId(this.$routeParams.CaseId).then(async (response) => {
        if (response != null && response.length > 0) {
          const currentUserId = await this.indexService.currentUserId;
          var currentShareholder = response.find((x) => x.userId == currentUserId);

          if (currentShareholder != null && currentShareholder.accessLevel == CaseAccessLevelEnum.ReadOnly) {
            (this.$rootScope as any).isInvitedAndHasReadonlyAccess = true;
          }
        }
        this.$rootScope.$broadcast("invitedStatusChange");
      });
    } else {
      this.$rootScope.$broadcast("invitedStatusChange");
    }
  }

  getLenderCount() {
    this.lenderClient.getTotalLenders(ProductFamilyEnum.Development).then((result) => {
      this.totalLender = result;
    });
  }

  closeConfirmationModal() {
    if (this.isSubmittedToLenders) {
      window.location.reload();
    }
    this.showTsAndCs = false;
  }

  getSelectedLenderName() {
    if (this.isBroker && this.case.developmentInput && this.case.developmentInput.selectedResults.length == 1) {
      this.productClient.fetch(this.case.developmentInput.selectedResults[0].productId).then((product: Product) => {
        this.selectedLendersText = product.lenderName;
      });
    }
  }

  redactInfo() {
    this.eventLogClient.logEvent(
      "EXPORTCASEPDFCLICKED",
      EventLogEnum.Export,
      ProductTypeEnum.Development,
      this.case.id,
    );
    if (this.isClient) {
      this.redactSensitiveInfo = true;
    }
  }

  autoFillComparable(save: boolean = true) {
    this.newComparable = this.initializeNewComparable();

    this.newComparable.caseId = this.case.id;
    this.newComparable.url = "https://www.rightmove.co.uk/properties/118409864#/?channel=RES_BUY";
    this.newComparable.propType = "4 bed detached house";
    this.newComparable.value = 1100000;
    this.newComparable.isGoodComparable = true;
    this.newComparable.comments =
      "It is a very similar spec and layout to our property and is in the same side of the road - south-facing";

    if (save) {
      this.saveComparable(this.newComparable);
    } else {
      this.case.comparables.push(this.newComparable);
    }

    this.newComparable = this.initializeNewComparable();

    this.newComparable.url = "https://www.rightmove.co.uk/properties/119098043#/?channel=RES_BUY";
    this.newComparable.propType = "4 bed detached house";
    this.newComparable.value = 1510000;
    this.newComparable.isGoodComparable = true;
    this.newComparable.comments = "Similar property - different street";
    this.newComparable.caseId = this.case.id;

    if (save) {
      this.saveComparable(this.newComparable);
    } else {
      this.case.comparables.push(this.newComparable);
    }
  }

  async autoFillTeammember(save: boolean = true) {
    const userId = await this.indexService.currentUserId;
    this.newTeamMember = this.initializeNewTeamMember(userId);

    this.newTeamMember.caseId = this.case.id;
    this.newTeamMember.teamRole = "TeamRole";
    this.newTeamMember.name = "Jane Doe";
    this.newTeamMember.email = "jane@jdarchitects.com";
    this.newTeamMember.website = "https://janedoearchitects.com/";
    this.newTeamMember.workedWithBefore = true;
    this.newTeamMember.previousProjects = "Worked with them on our project in Soho Square";

    if (save) {
      this.saveTeamMember(this.newTeamMember);
    } else {
      this.case.teamMembers.push(this.newTeamMember);
    }

    this.newTeamMember = this.initializeNewTeamMember(userId);
    this.newTeamMember.userId = await this.indexService.currentUserId;
    this.newTeamMember.caseId = this.case.id;
    this.newTeamMember.teamRole = "Main Contractor ";
    this.newTeamMember.name = "JS Build & Design";
    this.newTeamMember.email = "JS Build & Design";
    this.newTeamMember.website = "https://jsbuildanddesign.com/";
    this.newTeamMember.workedWithBefore = true;
    this.newTeamMember.previousProjects = "https://jsbuildanddesign.com/";

    if (save) {
      this.saveTeamMember(this.newTeamMember);
    } else {
      this.case.teamMembers.push(this.newTeamMember);
    }
  }

  // Removing due to errors in upgrade, if this is really needed, can be brought back & fixed
  // autofillCase() {
  //   this.autoFillComparable(false);
  //   this.autoFillTeammember(false);
  //   this.case.purchaseProcessType = PurchaseProcessTypeEnum.RegularPurchase;
  //   this.case.planningPermissionType = PlanningPermissionTypeEnum.DetailedPlanning;
  //   this.case.planningResponsibility = PlanningResponsibilityEnum.Borrower;
  //   this.case.planningDescription =
  //     "We purchased the site with outline planning 6 months ago, with a bridging loan.We havenow dealt with all reserved matters, and have detailed planning permission for 26x 3 & 4 bed houses.";
  //   this.case.siteDescriptionOnCompletion = "The site will be bare land at completion.";
  //   this.case.buildProcurementType = BuildProcurementTypeEnum.SelfManaged;
  //   this.case.buildProcurementDescription =
  //     "We are managing the build ourselves and will tender the individual packages. We have worked this way on 3x previous personal projects. Prior to that one of our shareholders worked as a PM for 10 years at a regional house builder, managing projects of up to 150 houses. ";
  //   this.case.depositDescription =
  //     "50% of the deposit will come from the shareholders and 50% will come from investors. The investors are family and friends and their investment will be secured as a 2nd charge.";
  //   this.case.guaranteeDescription = "This is the dummy text";
  //   this.case.developmentInput.cI_Dev_ExitStrategy = ExitStrategyEnum.PartSalePartRefinance;
  //   this.case.hasSetCompletionDate = true;
  //   let maxDate = Date.now();
  //   const timestamp = Math.floor(Math.random() * maxDate);
  //   this.case.completionDate = new Date(timestamp);
  //   this.case.developmentInput.searchPreferenceLoanSize = 1;
  //   this.case.developmentInput.searchPreferencePricing = 2;
  //   this.case.developmentInput.searchPreferenceCompletionSpeed = 3;
  //   this.case.developmentInput.searchPreferenceCustomerService = 4;
  //   this.case.developmentInput.howManyHouses = 2;
  //   this.caseClient.autofillCase(this.case).then((response) => {
  //     window.location.reload();
  //   });
  // }

  getNoteText(text: string) {
    if (this.isClient && text.startsWith("Project submitted to lenders")) {
      return "Project submitted to lenders";
    } else {
      return text;
    }
  }

  async updateRequestAssitanceCaseNoteMessage() {
    const currentUserId = await this.indexService.currentUserId;
    if (this.case?.caseNotes != null) {
      this.case.caseNotes = this.case.caseNotes.map((d) => {
        if (
          d.userId != currentUserId &&
          (d.noteText == "Your have requested for assistance." || d.noteText == "You have requested assistance.")
        ) {
          return { ...d, NoteText: `${d.user.name} requested assistance.` };
        }
        return d;
      });
    }
  }

  closeSubmitToLenderModal() {
    this.showTsAndCs = false;
    this.brokerCommission =
      this.case.caseStatus == CaseStatusEnum.NewCase ? this.org?.commissionPercent : this.case.brokerCommissionPercent;
    this.brokerPreferredContact =
      this.case.caseStatus == CaseStatusEnum.NewCase ? this.caseBrokerUser?.phoneNumber : this.case.brokerPhoneNumber;
    this.isBrokerPhoneNumberUpdated = false;
  }

  validateEmails() {
    this.invalidEmail = false;

    angular.forEach(this.lendersDetailsForSubmittoLenders, (lenderdetails, index) => {
      var emailField = this.lenderDetailsForm["email" + index];

      if (emailField && emailField.$invalid) {
        this.invalidEmail = true;
      }
    });
  }

  initializeNewExternalLink() {
    return {
      link: "https://",
      linkType: ExternalLinksEnum.Misc,
      description: "",
      case: null,
      id: 0,
      caseId: this.case.id,
      isDeleted: false,
      createdDateTime: null,
      lastUpdatedDateTime: null,
      lastModifiedUser: null,
      lastModifiedUserId: null,
      createdUserId: null,
      createdUser: null,
    };
  }

  initializeNewCaseNote(userId) {
    return {
      user: null,
      noteText: "",
      case: null,
      id: 0,
      userId: userId,
      caseId: this.case.id,
      isDeleted: false,
      createdDateTime: null,
      lastUpdatedDateTime: null,
      lastModifiedUser: null,
      lastModifiedUserId: null,
      createdUserId: null,
      createdUser: null,
    };
  }

  initializeNewTeamMember(userId) {
    return {
      user: null,
      case: null,
      teamRole: "",
      name: "",
      email: "",
      phoneNumber: "",
      website: "https://",
      workedWithBefore: false,
      previousProjects: "",
      externalProfileURL: "",
      note: "",
      teamRoleOtherDescription: "",
      id: 0,
      userId: userId,
      caseId: this.case.id,
      isDeleted: false,
      createdDateTime: null,
      lastUpdatedDateTime: null,
      lastModifiedUser: null,
      lastModifiedUserId: 0,
      createdUserId: 0,
      createdUser: null,
    };
  }

  initializeNewComparable() {
    return {
      case: null,
      propType: "",
      url: "https://",
      note: "",
      value: 0,
      comments: "",
      isGoodComparable: false,
      id: 0,
      caseId: this.case.id,
      isDeleted: false,
      createdDateTime: null,
      lastUpdatedDateTime: null,
      lastModifiedUser: null,
      lastModifiedUserId: 0,
      createdUserId: 0,
      createdUser: null,
    };
  }
}
